module.exports = __webpack_public_path__ + "img/49200.50b84cd2.jpg";